import http from "../http-common";

class LatestEventsService {
  getLatestEvents(numberOfEvents: number) {
    return http.get(`/events/latest?noOfEvents=${numberOfEvents.toString()}`);
  }
}

export default new LatestEventsService();
